export const UPDATE_LOCATION = 'UPDATE_LOCATION';
